<template>
        <div id="graph">
            <canvas id="dividendsGraph" width="600" height="200"></canvas>
        </div>
       
</template>
<script>
    import axios from 'axios';
    export default {       

        props: {
            portfolioguid: String,
            projected: Number
        },
        data: function () {
            return {
                portfolioGuid: this.portfolioguid,
                projectedDiv: this.projected
            };
        },
        methods: {
            async getDividendData() {                

                const { data } = await axios.get('/api/trades/GetDividendsByPortfolioByYear', {
                    params: {
                        portfolioGuid: this.portfolioGuid
                    }
                });   

                var projDiv = this.projectedDiv;
                
                data.forEach(function (element) {
                    if (element.year == new Date().getFullYear())
                        element.projectedDiv = projDiv;
                    else
                        element.projectedDiv = 0;
                });                

                var dividendData = {
                    type: 'bar',
                    data: {
                        labels: data.map(value => value.year),
                        datasets: [
                            { // one line graph
                                label: 'Total Dividends',
                                data: data.map(value => value.totalAmount),
                                backgroundColor: ['rgba(54,73,93,.5)'],
                                borderColor: ['#36495d'],
                                borderWidth: 0.5,
                                pointStyle: 'line',
                                pointRadius: 0
                            },
                            { // one line graph
                                label: 'Projected',
                                data: data.map(value => value.projectedDiv),
                                backgroundColor: "yellow",
                                borderColor: ['#36495d'],
                                borderWidth: 0.5,
                                categoryPercentage: 0.5
                            }

                        ]
                    },
                    options: {
                        responsive: true,
                        lineTension: 1,
                        scales: {
                            x: {
                                stacked: true
                            },
                            y: {
                                ticks: {
                                    beginAtZero: false,
                                    padding: 25,
                                }
                            }
                        }
                    }
                }

                this.createChart('dividendsGraph', dividendData);
            }
        },
        async mounted() {
            await this.getDividendData();
        }
    }
</script>